<template>
  <div class="bright-block">
    <h2 class="bright-block__title">
      Яркий вкус<span
        ><img
          class="_icon"
          src="../assets/img/bright-taste/title-icon.svg"
          alt="" /></span
      ><br />
      для ярких моментов
    </h2>
    <div class="bright-block__story">
      <div class="bright-block__story__line --left --line-1">
        <img class="_photo" src="../assets/img/bright-taste/photo-1.png" />
        <img class="_kr" src="../assets/img/bright-taste/kr-1.png" />
        <div class="_text">
          <div class="_row-1">Дома</div>
          <div class="_row-2">за любимым<br />сериалом</div>
          <img class="_connect" src="../assets/img/bright-taste/line-1.svg" />
        </div>
      </div>
      <div class="bright-block__story__line --right --line-2">
        <img class="_photo" src="../assets/img/bright-taste/photo-2.png" />
        <div class="_text">
          <div class="_row-1">В УНИВЕРЕ</div>
          <div class="_row-2">на паре или<br />в перерыве</div>
          <img class="_connect" src="../assets/img/bright-taste/line-2.svg" />
        </div>
      </div>
      <div class="bright-block__story__line --left --line-3">
        <img class="_photo" src="../assets/img/bright-taste/photo-3.png" />
        <img class="_kr" src="../assets/img/bright-taste/kr-2.png" />
        <div class="_text">
          <div class="_row-1">На вечеринке</div>
          <div class="_row-2">с друзьями</div>
          <img class="_connect" src="../assets/img/bright-taste/line-3.svg" />
        </div>
      </div>
      <div class="bright-block__story__line --right --line-4">
        <img class="_photo" src="../assets/img/bright-taste/photo-4.png" />
        <img class="_kr" src="../assets/img/bright-taste/kr-3.png" />
        <div class="_text">
          <div class="_row-1">В путешествии</div>
          <div class="_row-2">и в поезде, и у костра</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrightBlock",
}
</script>

<style lang="scss">
.bright-block {
  background-color: $color-yellow;
  padding: 126px 0;
  overflow: hidden;
  &__title {
    @include title();
    font-size: 11.2rem;
    position: relative;
    ._icon {
      position: absolute;
      left: 50%;
      top: -60px;
      transform: translateX(190px);
    }
  }
  &__story {
    color: $color-blue;
    max-width: 960px;
    margin: 80px auto 0;
    &__line {
      display: flex;
      ._photo {
        max-width: 420px;
      }
      ._text {
        position: relative;
        ._row-1 {
          font-family: $font-peach;
          font-size: 6.4rem;
        }
        ._row-2 {
          font-family: $font-text;
          font-size: 2.8rem;
          line-height: 0.95;
        }
      }
      ._connect {
        position: absolute;
      }
      &.--line-1 {
        position: relative;
        ._text {
          transform: rotate(-10deg) translateY(55px) translateX(40px);
        }
        ._connect {
          top: 148px;
          left: 82px;
          transform: rotate(12deg);
        }
        ._kr {
          max-width: 286px;
          position: absolute;
          top: -100px;
          right: 80px;
        }
      }
      &.--line-2 {
        flex-direction: row-reverse;
        margin-top: -130px;
        ._text {
          transform: rotate(2deg) translateY(125px) translateX(-20px);
        }
        ._photo {
          max-width: 460px;
        }
        ._connect {
          top: 85px;
          left: -95px;
        }
      }
      &.--line-3 {
        margin-top: -50px;
        position: relative;
        ._text {
          transform: rotate(-10deg) translateY(55px) translateX(20px);
        }
        ._kr {
          max-width: 215px;
          position: absolute;
          top: -45px;
          left: -40px;
        }
        ._connect {
          top: 135px;
          left: 135px;
          transform: rotate(10deg);
        }
      }
      &.--line-4 {
        flex-direction: row-reverse;
        margin-top: -115px;
        position: relative;
        ._text {
          transform: rotate(2deg) translateY(138px) translateX(-15px);
        }
        ._photo {
          max-width: 460px;
        }
        ._kr {
          max-width: 170px;
          position: absolute;
          top: -95px;
          right: -25px;
        }
      }
    }
  }
}
@include respond-to("small") {
  .bright-block {
    &__title {
      font-size: 8.6rem;
    }
  }
}
@include respond-to("smartphone-plus") {
  .bright-block {
    box-shadow: 0px 30px 80px rgba(56, 0, 1, 0.5);
    border-radius: 48px 48px 0px 0px;
    margin-top: -48px;
    position: relative;
    z-index: 20;
    padding: 96px 0;

    &__title {
      font-size: 4.8rem;
      ._icon {
        top: -17px;
        transform: translateX(75px);
        width: 60px;
      }
    }
    &__story {
      padding: 0 20px;
      margin-top: 0;
      &__line {
        display: block;
        text-align: center;
        ._photo {
          max-width: 90% !important;
        }
        ._text {
          ._row-1 {
            font-size: 4.4rem;
          }
          ._row-2 {
            font-size: 2.4rem;
            br {
              //   display: none;
              content: "";
              position: relative;
              &:before {
                content: " ";
              }
            }
          }
        }
      }
      &__line.--line-1 {
        ._text {
          transform: rotate(0) translate(0, 0);
        }
        ._connect {
          transform: rotate(-122deg) translate(25%, -45%);
          left: 50%;
        }
        ._kr {
          top: calc(100% + 30px);
          width: 154px;
          right: auto;
          left: calc(50% - 160px);
          z-index: 10;
        }
      }

      &__line.--line-2 {
        margin-top: 175px;
        ._text {
          transform: rotate(0) translate(0, 0);
          margin-top: -35px;
        }
        ._connect {
          top: 75px;
          left: calc(50% - 25px);
          height: 150px;
          transform: rotate(-198deg);
        }
      }

      &__line.--line-3 {
        margin-top: 130px;
        ._text {
          transform: rotate(0) translate(0, 0);
          margin-top: -20px;
        }
        ._kr {
          max-width: 200px;
          left: -25px;
        }
        ._connect {
          transform: rotate(-140deg);
          top: 112px;
          left: 121px;
          width: 85px;
        }
      }

      &__line.--line-4 {
        margin-top: 115px;
        ._text {
          transform: rotate(0) translate(0, 0);
          margin-top: -35px;
        }
        ._kr {
          right: 0;
          top: -99px;
        }
      }
    }
  }
}
</style>
